import { render } from "./SystemWarnMessageList.vue?vue&type=template&id=5e0e7e8b"
import script from "./SystemWarnMessageList.vue?vue&type=script&lang=js"
export * from "./SystemWarnMessageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/systemMessage/SystemWarnMessageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e0e7e8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e0e7e8b', __exports__)) {
    api.reload('5e0e7e8b', __exports__)
  }
  
  module.hot.accept("./SystemWarnMessageList.vue?vue&type=template&id=5e0e7e8b", () => {
    api.rerender('5e0e7e8b', render)
  })

}


export default __exports__